const smartfitSizingAvailable = (payload) => {
  const { id } = payload;
  const ozButton = document.getElementById(id);
  ozButton.classList.remove("onlinesizing-hidden");
};

const OZ_CONFIG = {
  settings: {
    apiKey: "oz_xNbelmYar7CoNBYw5xvcaurR0rDIH.PhE2hTuHIpbQv9v/dbK8lbK",
    primary: "#ff4e00",
    cta: "#000000",
    buttonTextColor: "#ffffff",
    units: "metric",
    frameSizeDisplay: "manufacturer",
    confirmSizeLabel: "Close",
  },
  events: {
    sizingAvailable: {
      callback: smartfitSizingAvailable,
    },
  }
};

((win, doc, script, key, config, src) => {
  win['___OnlineSizing'] = key;
  win['___OnlineSizingConfig'] = config;
  const js = doc.createElement(script);
  js.id = key;
  js.src = src;
  js.async = true;

  const scripts = doc.getElementsByTagName(script);
  const lastScript = scripts[scripts.length - 1];
  lastScript.parentNode.insertBefore(js, lastScript);
})(
  window,
  document,
  'script',
  'oz',
  OZ_CONFIG,
  'https://widgets.onlinesizing.bike/loader.js'
);